import { reviewItems } from "@/mocks/guaData";

export default function ReviewSection() {
  return (
    <section id="review" className="scroll-mt-24 w-full">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
              <i className="ri-quill-pen-line"></i> 深度复盘与细节汇总
            </span>
            <h2 className="font-heading mt-5 text-3xl md:text-4xl font-bold text-foreground-950">不止看热闹，更看懂门道</h2>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              精选高价值复盘内容，从方法论到观察视角，帮你在下次吃瓜时更快看懂来龙去脉。
            </p>
          </div>
          <button className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 w-fit">
            全部复盘内容 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reviewItems.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.title} 封面配图`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-medium text-primary-700">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950 line-clamp-2 group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">{item.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-400">
                    {item.meta} · {item.reads}
                  </span>
                  <i className="ri-arrow-right-line text-primary-500"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}